// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Manrope:wght@600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --auth-ink: #142337;
    --auth-muted: #66758a;
    --auth-navy: #20374f;
    --auth-coral: #ef6f53;
    --auth-coral-dark: #d9573f;
    --auth-line: #dfe6ed;
}

.auth-shell,
.auth-shell * {
    box-sizing: border-box;
}

.auth-shell {
    position: relative;
    display: grid;
    place-items: center;
    min-height: 100%;
    width: 100%;
    padding: clamp(1.25rem, 3vw, 3rem);
    overflow: hidden;
    color: var(--auth-ink);
    font-family: 'DM Sans', sans-serif;
    text-align: left;
    background:
        linear-gradient(rgba(255,255,255,.6) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255,255,255,.6) 1px, transparent 1px),
        radial-gradient(circle at 10% 15%, rgba(239,111,83,.22), transparent 26rem),
        radial-gradient(circle at 88% 88%, rgba(67,101,134,.2), transparent 28rem),
        #eef3f7;
    background-size: 42px 42px, 42px 42px, auto, auto, auto;
}

.auth-orb {
    position: absolute;
    border-radius: 999px;
    filter: blur(1px);
    pointer-events: none;
}

.auth-orb-one {
    width: 180px;
    height: 180px;
    top: -90px;
    right: 8%;
    background: linear-gradient(145deg, rgba(239,111,83,.75), rgba(255,190,144,.15));
}

.auth-orb-two {
    width: 120px;
    height: 120px;
    bottom: -62px;
    left: 7%;
    border: 26px solid rgba(54,76,99,.13);
}

.auth-shell-card {
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: minmax(330px, .92fr) minmax(430px, 1.08fr);
    width: min(1080px, 100%);
    min-height: min(640px, calc(100vh - 10rem));
    overflow: hidden;
    border: 1px solid rgba(255,255,255,.8);
    border-radius: 28px;
    background: rgba(255,255,255,.88);
    box-shadow: 0 30px 80px rgba(31,55,78,.18), 0 3px 12px rgba(31,55,78,.08);
    backdrop-filter: blur(18px);
}

.auth-story {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: clamp(2rem, 4vw, 3.75rem);
    overflow: hidden;
    color: #fff;
    background:
        radial-gradient(circle at 90% 4%, rgba(239,111,83,.72), transparent 15rem),
        linear-gradient(145deg, #304d67 0%, #1b3045 56%, #122336 100%);
}

.auth-story::before,
.auth-story::after {
    content: '';
    position: absolute;
    border-radius: 999px;
    pointer-events: none;
}

.auth-story::before {
    width: 300px;
    height: 300px;
    right: -170px;
    bottom: 60px;
    border: 1px solid rgba(255,255,255,.14);
    box-shadow: 0 0 0 45px rgba(255,255,255,.035), 0 0 0 90px rgba(255,255,255,.025);
}

.auth-story::after {
    width: 8px;
    height: 8px;
    left: 18%;
    top: 30%;
    background: var(--auth-coral);
    box-shadow: 54px 70px 0 rgba(255,255,255,.24), 240px -50px 0 rgba(255,255,255,.18);
}

.auth-brand {
    position: relative;
    z-index: 1;
    display: inline-flex;
    align-self: flex-start;
    padding: .7rem 1rem;
    border-radius: 13px;
    background: #fff;
    box-shadow: 0 10px 30px rgba(0,0,0,.16);
}

.auth-brand img {
    display: block;
    width: 148px;
    height: auto;
}

.auth-story-copy {
    position: relative;
    z-index: 1;
    margin: auto 0;
    padding: 2.5rem 0;
}

.auth-kicker {
    display: inline-flex;
    align-items: center;
    gap: .6rem;
    margin-bottom: 1.35rem;
    color: #ffd6cd;
    font-size: .77rem;
    font-weight: 700;
    letter-spacing: .13em;
    text-transform: uppercase;
}

.auth-story h2,
.auth-form-wrap h1 {
    font-family: 'Manrope', sans-serif;
}

.auth-story h2 {
    max-width: 430px;
    margin: 0 0 1.2rem;
    color: #fff;
    font-size: clamp(2.2rem, 4vw, 3.6rem);
    line-height: 1.08;
    letter-spacing: -.045em;
}

.auth-story-copy > p {
    max-width: 420px;
    margin: 0;
    color: rgba(255,255,255,.73);
    font-size: 1.03rem;
    line-height: 1.75;
}

.auth-trust-grid {
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: .7rem;
}

.auth-trust-grid > div {
    min-width: 0;
    padding: .9rem .75rem;
    border: 1px solid rgba(255,255,255,.1);
    border-radius: 15px;
    background: rgba(255,255,255,.06);
}

.auth-trust-icon {
    display: block;
    margin-bottom: .7rem;
    color: #ff9d87;
}

.auth-trust-grid strong,
.auth-trust-grid small {
    display: block;
}

.auth-trust-grid strong {
    margin-bottom: .18rem;
    font-size: .87rem;
}

.auth-trust-grid small {
    overflow: hidden;
    color: rgba(255,255,255,.55);
    font-size: .69rem;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.auth-form-panel {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: clamp(2rem, 5vw, 4.5rem);
    background: rgba(255,255,255,.94);
}

.auth-form-wrap {
    width: min(420px, 100%);
    margin: auto;
}

.auth-mobile-brand {
    display: none;
}

.auth-form-eyebrow {
    display: block;
    margin-bottom: .85rem;
    color: var(--auth-coral-dark);
    font-size: .76rem;
    font-weight: 800;
    letter-spacing: .16em;
    text-transform: uppercase;
}

.auth-form-wrap h1 {
    margin: 0;
    color: var(--auth-ink);
    font-size: clamp(2rem, 3.5vw, 2.8rem);
    line-height: 1.15;
    letter-spacing: -.045em;
}

.auth-form-description {
    margin: .9rem 0 2rem;
    color: var(--auth-muted);
    font-size: .96rem;
    line-height: 1.65;
}

.auth-form {
    display: flex;
    flex-direction: column;
    gap: 1.15rem;
}

.auth-field label {
    display: block;
    margin: 0 0 .5rem;
    color: #34465a;
    font-size: .82rem;
    font-weight: 700;
}

.auth-input-wrap {
    position: relative;
}

.auth-input-icon {
    position: absolute;
    z-index: 1;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    color: #8a98a8;
    font-size: .88rem;
    pointer-events: none;
}

.auth-input-wrap input {
    width: 100%;
    height: 3.35rem;
    margin: 0;
    padding: 0 3rem 0 2.8rem;
    border: 1px solid var(--auth-line);
    border-radius: 13px;
    outline: none;
    color: var(--auth-ink);
    font: 500 .95rem 'DM Sans', sans-serif;
    background: #f9fbfc;
    transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
}

.auth-input-wrap input::placeholder {
    color: #9aa6b3;
}

.auth-input-wrap input:focus {
    border-color: var(--auth-coral);
    background: #fff;
    box-shadow: 0 0 0 4px rgba(239,111,83,.11);
}

.auth-input-wrap input:disabled {
    cursor: not-allowed;
    opacity: .68;
}

.auth-password-toggle {
    position: absolute;
    right: .65rem;
    top: 50%;
    transform: translateY(-50%);
    display: grid;
    place-items: center;
    width: 2.15rem;
    height: 2.15rem;
    padding: 0;
    border: 0;
    border-radius: 9px;
    color: #788697;
    background: transparent;
    cursor: pointer;
}

.auth-password-toggle:hover {
    color: var(--auth-ink);
    background: #edf2f6;
}

.auth-submit {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: .65rem;
    width: 100%;
    min-height: 3.35rem;
    margin-top: .25rem;
    padding: .8rem 1.2rem;
    border: 0;
    border-radius: 13px;
    color: #fff;
    font: 700 .95rem 'DM Sans', sans-serif;
    background: linear-gradient(135deg, #f37b61, #e75f43);
    box-shadow: 0 13px 28px rgba(239,111,83,.28);
    cursor: pointer;
    transition: transform .2s ease, box-shadow .2s ease, filter .2s ease;
}

.auth-submit:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 17px 34px rgba(239,111,83,.36);
    filter: saturate(1.06);
}

.auth-submit:disabled {
    cursor: not-allowed;
    opacity: .65;
}

.auth-inline-link {
    color: var(--auth-coral-dark);
    font-size: .86rem;
    font-weight: 700;
    text-decoration: none;
}

.auth-inline-link:hover {
    text-decoration: underline;
}

.auth-form-footer {
    display: flex;
    justify-content: center;
    margin-top: 1.35rem;
}

.auth-alert {
    display: flex;
    align-items: flex-start;
    gap: .65rem;
    margin-bottom: 1rem;
    padding: .8rem .95rem;
    border: 1px solid;
    border-radius: 12px;
    font-size: .83rem;
    line-height: 1.5;
}

.auth-alert-error {
    border-color: #ffd3cb;
    color: #a83825;
    background: #fff5f3;
}

.auth-alert-success {
    border-color: #bde8d1;
    color: #176641;
    background: #f0fbf5;
}

.auth-security-note {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: .45rem;
    margin: 2rem 0 0;
    color: #98a3af;
    font-size: .72rem;
}

@media (max-width: 820px) {
    .auth-shell {
        display: block;
        min-height: 100%;
        padding: 1rem;
        overflow: auto;
    }

    .auth-shell-card {
        display: block;
        width: min(540px, 100%);
        min-height: 0;
        margin: 0 auto;
        border-radius: 22px;
    }

    .auth-story {
        display: none;
    }

    .auth-form-panel {
        min-height: calc(100vh - 2rem);
        padding: 2rem clamp(1.4rem, 7vw, 3rem);
    }

    .auth-mobile-brand {
        display: block;
        margin-bottom: 2rem;
    }

    .auth-mobile-brand img {
        width: 142px;
        height: auto;
    }
}

@media (max-width: 480px) {
    .auth-shell {
        padding: 0;
        background: #fff;
    }

    .auth-shell-card {
        border: 0;
        border-radius: 0;
        box-shadow: none;
    }

    .auth-form-panel {
        min-height: 100vh;
        padding: 1.5rem 1.25rem;
    }
}

@media (prefers-reduced-motion: reduce) {
    .auth-submit,
    .auth-input-wrap input {
        transition: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Sign/AuthShell/AuthShell.css"],"names":[],"mappings":"AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;IACrB,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,kCAAkC;IAClC,gBAAgB;IAChB,sBAAsB;IACtB,kCAAkC;IAClC,gBAAgB;IAChB;;;;;eAKW;IACX,uDAAuD;AAC3D;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,UAAU;IACV,SAAS;IACT,gFAAgF;AACpF;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,QAAQ;IACR,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,iEAAiE;IACjE,wBAAwB;IACxB,2CAA2C;IAC3C,gBAAgB;IAChB,sCAAsC;IACtC,mBAAmB;IACnB,iCAAiC;IACjC,yEAAyE;IACzE,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,kCAAkC;IAClC,gBAAgB;IAChB,WAAW;IACX;;sEAEkE;AACtE;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,YAAY;IACZ,uCAAuC;IACvC,gFAAgF;AACpF;;AAEA;IACI,UAAU;IACV,WAAW;IACX,SAAS;IACT,QAAQ;IACR,6BAA6B;IAC7B,kFAAkF;AACtF;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,UAAU;IACV,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,qCAAqC;IACrC,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,4BAA4B;IAC5B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,sCAAsC;IACtC,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,qCAAqC;IACrC,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,wBAAwB;IACxB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,SAAS;IACT,wBAAwB;IACxB,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,sCAAsC;IACtC,mBAAmB;IACnB,2EAA2E;AAC/E;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,sCAAsC;IACtC,qDAAqD;IACrD,4CAA4C;IAC5C,eAAe;IACf,oEAAoE;AACxE;;AAEA;IACI,2BAA2B;IAC3B,4CAA4C;IAC5C,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,gBAAgB;QAChB,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,uBAAuB;QACvB,aAAa;QACb,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,8BAA8B;QAC9B,sCAAsC;IAC1C;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;;QAEI,gBAAgB;IACpB;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Manrope:wght@600;700;800&display=swap');\n\n:root {\n    --auth-ink: #142337;\n    --auth-muted: #66758a;\n    --auth-navy: #20374f;\n    --auth-coral: #ef6f53;\n    --auth-coral-dark: #d9573f;\n    --auth-line: #dfe6ed;\n}\n\n.auth-shell,\n.auth-shell * {\n    box-sizing: border-box;\n}\n\n.auth-shell {\n    position: relative;\n    display: grid;\n    place-items: center;\n    min-height: 100%;\n    width: 100%;\n    padding: clamp(1.25rem, 3vw, 3rem);\n    overflow: hidden;\n    color: var(--auth-ink);\n    font-family: 'DM Sans', sans-serif;\n    text-align: left;\n    background:\n        linear-gradient(rgba(255,255,255,.6) 1px, transparent 1px),\n        linear-gradient(90deg, rgba(255,255,255,.6) 1px, transparent 1px),\n        radial-gradient(circle at 10% 15%, rgba(239,111,83,.22), transparent 26rem),\n        radial-gradient(circle at 88% 88%, rgba(67,101,134,.2), transparent 28rem),\n        #eef3f7;\n    background-size: 42px 42px, 42px 42px, auto, auto, auto;\n}\n\n.auth-orb {\n    position: absolute;\n    border-radius: 999px;\n    filter: blur(1px);\n    pointer-events: none;\n}\n\n.auth-orb-one {\n    width: 180px;\n    height: 180px;\n    top: -90px;\n    right: 8%;\n    background: linear-gradient(145deg, rgba(239,111,83,.75), rgba(255,190,144,.15));\n}\n\n.auth-orb-two {\n    width: 120px;\n    height: 120px;\n    bottom: -62px;\n    left: 7%;\n    border: 26px solid rgba(54,76,99,.13);\n}\n\n.auth-shell-card {\n    position: relative;\n    z-index: 1;\n    display: grid;\n    grid-template-columns: minmax(330px, .92fr) minmax(430px, 1.08fr);\n    width: min(1080px, 100%);\n    min-height: min(640px, calc(100vh - 10rem));\n    overflow: hidden;\n    border: 1px solid rgba(255,255,255,.8);\n    border-radius: 28px;\n    background: rgba(255,255,255,.88);\n    box-shadow: 0 30px 80px rgba(31,55,78,.18), 0 3px 12px rgba(31,55,78,.08);\n    backdrop-filter: blur(18px);\n}\n\n.auth-story {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: clamp(2rem, 4vw, 3.75rem);\n    overflow: hidden;\n    color: #fff;\n    background:\n        radial-gradient(circle at 90% 4%, rgba(239,111,83,.72), transparent 15rem),\n        linear-gradient(145deg, #304d67 0%, #1b3045 56%, #122336 100%);\n}\n\n.auth-story::before,\n.auth-story::after {\n    content: '';\n    position: absolute;\n    border-radius: 999px;\n    pointer-events: none;\n}\n\n.auth-story::before {\n    width: 300px;\n    height: 300px;\n    right: -170px;\n    bottom: 60px;\n    border: 1px solid rgba(255,255,255,.14);\n    box-shadow: 0 0 0 45px rgba(255,255,255,.035), 0 0 0 90px rgba(255,255,255,.025);\n}\n\n.auth-story::after {\n    width: 8px;\n    height: 8px;\n    left: 18%;\n    top: 30%;\n    background: var(--auth-coral);\n    box-shadow: 54px 70px 0 rgba(255,255,255,.24), 240px -50px 0 rgba(255,255,255,.18);\n}\n\n.auth-brand {\n    position: relative;\n    z-index: 1;\n    display: inline-flex;\n    align-self: flex-start;\n    padding: .7rem 1rem;\n    border-radius: 13px;\n    background: #fff;\n    box-shadow: 0 10px 30px rgba(0,0,0,.16);\n}\n\n.auth-brand img {\n    display: block;\n    width: 148px;\n    height: auto;\n}\n\n.auth-story-copy {\n    position: relative;\n    z-index: 1;\n    margin: auto 0;\n    padding: 2.5rem 0;\n}\n\n.auth-kicker {\n    display: inline-flex;\n    align-items: center;\n    gap: .6rem;\n    margin-bottom: 1.35rem;\n    color: #ffd6cd;\n    font-size: .77rem;\n    font-weight: 700;\n    letter-spacing: .13em;\n    text-transform: uppercase;\n}\n\n.auth-story h2,\n.auth-form-wrap h1 {\n    font-family: 'Manrope', sans-serif;\n}\n\n.auth-story h2 {\n    max-width: 430px;\n    margin: 0 0 1.2rem;\n    color: #fff;\n    font-size: clamp(2.2rem, 4vw, 3.6rem);\n    line-height: 1.08;\n    letter-spacing: -.045em;\n}\n\n.auth-story-copy > p {\n    max-width: 420px;\n    margin: 0;\n    color: rgba(255,255,255,.73);\n    font-size: 1.03rem;\n    line-height: 1.75;\n}\n\n.auth-trust-grid {\n    position: relative;\n    z-index: 1;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: .7rem;\n}\n\n.auth-trust-grid > div {\n    min-width: 0;\n    padding: .9rem .75rem;\n    border: 1px solid rgba(255,255,255,.1);\n    border-radius: 15px;\n    background: rgba(255,255,255,.06);\n}\n\n.auth-trust-icon {\n    display: block;\n    margin-bottom: .7rem;\n    color: #ff9d87;\n}\n\n.auth-trust-grid strong,\n.auth-trust-grid small {\n    display: block;\n}\n\n.auth-trust-grid strong {\n    margin-bottom: .18rem;\n    font-size: .87rem;\n}\n\n.auth-trust-grid small {\n    overflow: hidden;\n    color: rgba(255,255,255,.55);\n    font-size: .69rem;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n.auth-form-panel {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: clamp(2rem, 5vw, 4.5rem);\n    background: rgba(255,255,255,.94);\n}\n\n.auth-form-wrap {\n    width: min(420px, 100%);\n    margin: auto;\n}\n\n.auth-mobile-brand {\n    display: none;\n}\n\n.auth-form-eyebrow {\n    display: block;\n    margin-bottom: .85rem;\n    color: var(--auth-coral-dark);\n    font-size: .76rem;\n    font-weight: 800;\n    letter-spacing: .16em;\n    text-transform: uppercase;\n}\n\n.auth-form-wrap h1 {\n    margin: 0;\n    color: var(--auth-ink);\n    font-size: clamp(2rem, 3.5vw, 2.8rem);\n    line-height: 1.15;\n    letter-spacing: -.045em;\n}\n\n.auth-form-description {\n    margin: .9rem 0 2rem;\n    color: var(--auth-muted);\n    font-size: .96rem;\n    line-height: 1.65;\n}\n\n.auth-form {\n    display: flex;\n    flex-direction: column;\n    gap: 1.15rem;\n}\n\n.auth-field label {\n    display: block;\n    margin: 0 0 .5rem;\n    color: #34465a;\n    font-size: .82rem;\n    font-weight: 700;\n}\n\n.auth-input-wrap {\n    position: relative;\n}\n\n.auth-input-icon {\n    position: absolute;\n    z-index: 1;\n    left: 1rem;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #8a98a8;\n    font-size: .88rem;\n    pointer-events: none;\n}\n\n.auth-input-wrap input {\n    width: 100%;\n    height: 3.35rem;\n    margin: 0;\n    padding: 0 3rem 0 2.8rem;\n    border: 1px solid var(--auth-line);\n    border-radius: 13px;\n    outline: none;\n    color: var(--auth-ink);\n    font: 500 .95rem 'DM Sans', sans-serif;\n    background: #f9fbfc;\n    transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;\n}\n\n.auth-input-wrap input::placeholder {\n    color: #9aa6b3;\n}\n\n.auth-input-wrap input:focus {\n    border-color: var(--auth-coral);\n    background: #fff;\n    box-shadow: 0 0 0 4px rgba(239,111,83,.11);\n}\n\n.auth-input-wrap input:disabled {\n    cursor: not-allowed;\n    opacity: .68;\n}\n\n.auth-password-toggle {\n    position: absolute;\n    right: .65rem;\n    top: 50%;\n    transform: translateY(-50%);\n    display: grid;\n    place-items: center;\n    width: 2.15rem;\n    height: 2.15rem;\n    padding: 0;\n    border: 0;\n    border-radius: 9px;\n    color: #788697;\n    background: transparent;\n    cursor: pointer;\n}\n\n.auth-password-toggle:hover {\n    color: var(--auth-ink);\n    background: #edf2f6;\n}\n\n.auth-submit {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: .65rem;\n    width: 100%;\n    min-height: 3.35rem;\n    margin-top: .25rem;\n    padding: .8rem 1.2rem;\n    border: 0;\n    border-radius: 13px;\n    color: #fff;\n    font: 700 .95rem 'DM Sans', sans-serif;\n    background: linear-gradient(135deg, #f37b61, #e75f43);\n    box-shadow: 0 13px 28px rgba(239,111,83,.28);\n    cursor: pointer;\n    transition: transform .2s ease, box-shadow .2s ease, filter .2s ease;\n}\n\n.auth-submit:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 17px 34px rgba(239,111,83,.36);\n    filter: saturate(1.06);\n}\n\n.auth-submit:disabled {\n    cursor: not-allowed;\n    opacity: .65;\n}\n\n.auth-inline-link {\n    color: var(--auth-coral-dark);\n    font-size: .86rem;\n    font-weight: 700;\n    text-decoration: none;\n}\n\n.auth-inline-link:hover {\n    text-decoration: underline;\n}\n\n.auth-form-footer {\n    display: flex;\n    justify-content: center;\n    margin-top: 1.35rem;\n}\n\n.auth-alert {\n    display: flex;\n    align-items: flex-start;\n    gap: .65rem;\n    margin-bottom: 1rem;\n    padding: .8rem .95rem;\n    border: 1px solid;\n    border-radius: 12px;\n    font-size: .83rem;\n    line-height: 1.5;\n}\n\n.auth-alert-error {\n    border-color: #ffd3cb;\n    color: #a83825;\n    background: #fff5f3;\n}\n\n.auth-alert-success {\n    border-color: #bde8d1;\n    color: #176641;\n    background: #f0fbf5;\n}\n\n.auth-security-note {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: .45rem;\n    margin: 2rem 0 0;\n    color: #98a3af;\n    font-size: .72rem;\n}\n\n@media (max-width: 820px) {\n    .auth-shell {\n        display: block;\n        min-height: 100%;\n        padding: 1rem;\n        overflow: auto;\n    }\n\n    .auth-shell-card {\n        display: block;\n        width: min(540px, 100%);\n        min-height: 0;\n        margin: 0 auto;\n        border-radius: 22px;\n    }\n\n    .auth-story {\n        display: none;\n    }\n\n    .auth-form-panel {\n        min-height: calc(100vh - 2rem);\n        padding: 2rem clamp(1.4rem, 7vw, 3rem);\n    }\n\n    .auth-mobile-brand {\n        display: block;\n        margin-bottom: 2rem;\n    }\n\n    .auth-mobile-brand img {\n        width: 142px;\n        height: auto;\n    }\n}\n\n@media (max-width: 480px) {\n    .auth-shell {\n        padding: 0;\n        background: #fff;\n    }\n\n    .auth-shell-card {\n        border: 0;\n        border-radius: 0;\n        box-shadow: none;\n    }\n\n    .auth-form-panel {\n        min-height: 100vh;\n        padding: 1.5rem 1.25rem;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .auth-submit,\n    .auth-input-wrap input {\n        transition: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
